import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../environments/environment'
import { ProfileType } from '../models/profiletype.model';


const baseUrl = environment.baseUrl;

@Injectable({
  providedIn: 'root'
})
export class ExecService {

  constructor(private http: HttpClient) { } 

  SaveDeliverableTask(data: any):Observable<any>{
    var url = `${baseUrl}SaveDeliverableTask`;
    return this.http.post(url,data);
  }
  
  deleteDeliverableTask(id: any):Observable<any>{
    var url = `${baseUrl}DeleteDeliverableTask/${id}`;
    return this.http.post(url,id);
  }
  
  deleteDeliverable(id: any):Observable<any>{
    var url = `${baseUrl}DeleteDeliverable/${id}`;
    return this.http.post(url,id);
  }
  getADUsers():Observable<any>{
    var url = `${baseUrl}GetADUsers`;
    return this.http.get<any[]>(url);
  }
  
  getProfile() {
    return this.http.get<ProfileType>(environment.apiConfig.uri);
  }
}
